/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Promise_LeadInputs */

const en_mk_promise_lead = /** @type {(inputs: Mk_Promise_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not an empty chatbot you have to teach from scratch. Not a daemon you have to install and keep running. KerjaBareng ships agents ready per division, puts them on the same board as your team, and locks every outbound action behind your approval.`)
};

const id_mk_promise_lead = /** @type {(inputs: Mk_Promise_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bukan chatbot kosong yang harus kamu ajari dari nol. Bukan daemon yang harus kamu instal dan jaga tetap menyala. KerjaBareng menyiapkan agen siap pakai per divisi, menaruhnya di papan kerja yang sama dengan timmu, dan mengunci setiap aksi keluar di belakang persetujuanmu.`)
};

/**
* | output |
* | --- |
* | "Not an empty chatbot you have to teach from scratch. Not a daemon you have to install and keep running. KerjaBareng ships agents ready per division, puts the..." |
*
* @param {Mk_Promise_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_promise_lead = /** @type {((inputs?: Mk_Promise_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Promise_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_promise_lead(inputs)
	return en_mk_promise_lead(inputs)
});